import React, {} from 'react';

function SpinnerElement(props) {

  const attributes = {
    ...props.attributes,
    userselect: 'none',
    contentEditable: false
  };

  return <span {...attributes}>
    <ht-inline-spinner />
    {props.children}
  </span>;

}

export default SpinnerElement;